module.exports = __webpack_public_path__ + "img/phone-icn.feeb8b4a.png";